/**
 * Nesse arquivo vamos criar algumas funções e constantes para definir campos obrigatórios
 * na solicitação com base no ERP utilizado.
 *
 * Isso será substituido futuramente por uma API que irá retornar essas informações.
 *
 * por enquanto vamos criar um mock para simular essa API, mas com os valores reais.
 * No futuro, podemos substituir esse arquivo pelas requests diretamente.
 */


import moment from 'moment';
import { formatToCode } from '@/utils/moment-date-utils';
import { UrgenciaRequisicao } from 'px-business-components';

/**
 * Aqui, podemos mapear os campos que serão bloqueados para edição
 * em cada ERP. Também podemos definir por entidade, caso seja necessário.
 * @type {{TOTVS: {campos: string[]}}}
 */
const ERP_CAMPOS_BLOQUEADOS_EDICAO = {
  TOTVS: {
    campos: ['comprador'],
  },
};

const ERP_CAMPOS_HIDDEN_MAP = {
  CASA_SHOPPING: {
    camposItens: ['centroCusto'],
  },
};

const ERP_CAMPOS_PADROES_MAP = {
  SENIOR_MEGA_SERPOL: {
    campos: [
      { key: 'urgencia', value: UrgenciaRequisicao.keys.MEDIA.key },
      { key: 'dataEntrega', value: formatToCode(moment()) },
    ],
  },
};

const ERP_CAMPOS_OBRIGATORIOS_MAP = {
  TOTVS: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  TOTVS_PROTHEUS: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SANKHYA: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SANKHYA_NORSIL: {
    campos: ['centroCusto', 'projeto'],
    camposItens: ['centroCusto', 'projeto'],
  },
  SANKHYA_ART_LATEX: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SENIOR: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SENIOR_TEIXEIRA: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  FOCCO: {
    campos: ['centroCusto', 'compradoresResponsaveis'],
    camposItens: ['centroCusto'],
  },
  USEALL_SETUP: {
    campos: ['compradoresResponsaveis'],
  },
  USEALL_PROCER: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SENIOR_MEGA: {
    campos: ['centroCusto', 'projeto'],
    camposItens: ['centroCusto', 'projeto'],
  },
  SENIOR_MEGA_SERPOL: {
    campos: ['projeto'],
    camposItens: ['projeto'],
  },
  CASA_SHOPPING: {
    campos: ['centroCusto'],
  },
  SENIOR_PFIFFNER: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  SAP_B1: {
    campos: ['centroCusto'],
    camposItens: ['centroCusto'],
  },
  ELITE_SOFT: {
    campos: ['projeto', 'centroCusto'],
    camposItens: ['projeto', 'centroCusto'],
  },
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposObrigatorios = async (erpCamposIntegracao) => {
  const camposObrigatorios = ERP_CAMPOS_OBRIGATORIOS_MAP[erpCamposIntegracao];
  if (!camposObrigatorios) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposObrigatorios);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposHidden = async (erpCamposIntegracao) => {
  const camposHidden = ERP_CAMPOS_HIDDEN_MAP[erpCamposIntegracao];
  if (!camposHidden) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposHidden);
};

/**
 * Retorna uma promise para simular uma request e ficar mais fácil de lidar com isso depois
 * @param erpCamposIntegracao
 * @returns {Promise<Awaited<*>|Awaited<null>>}
 */
const getCamposPadroes = async (erpCamposIntegracao) => {
  const camposPadroes = ERP_CAMPOS_PADROES_MAP[erpCamposIntegracao];
  if (!camposPadroes) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposPadroes);
};

const getCamposBloqueadosEdicao = async (entidadeErp) => {
  const { idEntidade, erpCamposIntegracao } = entidadeErp;
  const camposBloquadosEntidade = ERP_CAMPOS_BLOQUEADOS_EDICAO[idEntidade];
  if (camposBloquadosEntidade) {
    return Promise.resolve(camposBloquadosEntidade);
  }
  const camposBloquados = ERP_CAMPOS_BLOQUEADOS_EDICAO[erpCamposIntegracao];
  if (!camposBloquados) {
    return Promise.resolve(null);
  }
  return Promise.resolve(camposBloquados);
};

export default {
  getCamposObrigatorios,
  getCamposHidden,
  getCamposPadroes,
  getCamposBloqueadosEdicao,
};
